// Desktop Chrome, Edge, Opera, Brave and ChromeOS report "Chrome/" and install Chrome Web Store extensions.
// Android Chromium (incl. Samsung Internet) also reports "Chrome/" but cannot; iOS Chrome reports "CriOS/".
// Android tablets in Chrome's desktop mode send a Linux desktop UA, so touch-capable Linux (not ChromeOS) counts as
// Android; the rare touchscreen Linux desktop is excluded with it.
export const isDesktopChromium = () => {
  const { maxTouchPoints, userAgent } = navigator;
  const isAndroidInDesktopMode = userAgent.includes('X11; Linux') && (maxTouchPoints ?? 0) > 0;

  return userAgent.includes('Chrome/') && !userAgent.includes('Android') && !userAgent.includes('Mobile') && !isAndroidInDesktopMode;
};
